export default {
    apiBaseUrl: 'https://api.albertmagazin.de',
    hcaptchaSiteKey: '744e063a-75ac-4fde-ba00-dc642eb489d6'
}
